import { buildStyleFns, buildStylePropFn } from './buildStyleFns';
export var otherStyleFnConfigs = [
    {
        name: 'animation',
        properties: ['animation'],
        system: 'none',
    },
    {
        name: 'appearance',
        properties: ['appearance'],
        system: 'none',
    },
    {
        name: 'boxSizing',
        properties: ['boxSizing'],
        system: 'none',
    },
    {
        name: 'content',
        properties: ['content'],
        system: 'none',
    },
    {
        name: 'cursor',
        properties: ['cursor'],
        system: 'none',
    },
    {
        name: 'fill',
        properties: ['fill'],
        system: 'none',
    },
    {
        name: 'float',
        properties: ['float'],
        system: 'none',
    },
    {
        name: 'objectFit',
        properties: ['objectFit'],
        system: 'none',
    },
    {
        name: 'objectPosition',
        properties: ['objectPosition'],
        system: 'none',
    },
    {
        name: 'outline',
        properties: ['outline'],
        system: 'none',
    },
    {
        name: 'outlineOffset',
        properties: ['outlineOffset'],
        system: 'none',
    },
    {
        name: 'overflowWrap',
        properties: ['overflowWrap'],
        system: 'none',
    },
    {
        name: 'pointerEvents',
        properties: ['pointerEvents'],
        system: 'none',
    },
    {
        name: 'resize',
        properties: ['resize'],
        system: 'none',
    },
    {
        name: 'stroke',
        properties: ['stroke'],
        system: 'none',
    },
    {
        name: 'transform',
        properties: ['transform'],
        system: 'none',
    },
    {
        name: 'transition',
        properties: ['transition'],
        system: 'none',
    },
    {
        name: 'userSelect',
        properties: ['userSelect'],
        system: 'none',
    },
    {
        name: 'visibility',
        properties: ['visibility'],
        system: 'none',
    },
];
export var otherStyleFns = buildStyleFns(otherStyleFnConfigs);
export var other = buildStylePropFn(otherStyleFns);
